import React from 'react';
import ReactDOM from 'react-dom';
import Widget from './components/Widget.js';

const elements = document.querySelectorAll('content-collection');

/**
 * Find all <content-collection/> tags and instantiate
 */
for (let i = 0; i < elements.length; i++) {
	/**
	 * Here we take all data- attributes into an array, and pass to the Config JS to get
	 * a normalized config array.
	 */
	let element = elements[i];
	let options = {};

	// we use init attribute to see if it's already been hooked by React
	if ('true' === element.getAttribute('init')) {
		continue;
	}
	element.setAttribute('init', 'true');

	let atts = element.attributes;
	for (let j = 0; j < atts.length; j++) {
		options[String(atts[j].nodeName).replace(/^data-/, '')] = atts[j].nodeValue;
	}

	// @TODO TEMP FOR TESTING
	ReactDOM.render(
		<React.StrictMode>
			<Widget options={options} />
		</React.StrictMode>,
		element
	);
}
